function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.83,
    height: 16.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7816666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 8.345,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.69,
    width: 28.83,
    height: 17.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.582
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 25.645000000000003,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.6,
    width: 28.83,
    height: 18.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.108333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 43.925,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.26,
    width: 28.83,
    height: 20.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.436666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 63.57,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.87,
    width: 28.83,
    height: 21.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.71875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 84.745,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95.62,
    width: 28.83,
    height: 27.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 109.53,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.44,
    width: 28.83,
    height: 31.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.766
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 138.97,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.5,
    width: 28.83,
    height: 32.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.118571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 170.615,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 186.74,
    width: 28.83,
    height: 33.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.118571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 203.52,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.29,
    width: 28.83,
    height: 33.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.766
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 237.19,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.09,
    width: 28.83,
    height: 35.17,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 271.675,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.26,
    width: 28.83,
    height: 35.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 306.885,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 324.51,
    width: 28.83,
    height: 37.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 343.465,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362.43,
    width: 28.83,
    height: 38.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 381.615,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 400.8,
    width: 28.83,
    height: 38.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.118571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 420.21000000000004,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 439.62,
    width: 28.83,
    height: 40.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.118571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 459.815,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480,
    width: 28.83,
    height: 40.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.118571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 500.375,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 520.75,
    width: 28.83,
    height: 42.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.60375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 541.875,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.01,
    width: 28.83,
    height: 43.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.766
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 584.68,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 606.35,
    width: 28.83,
    height: 45.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.766
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 629.1800000000001,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 652.01,
    width: 28.83,
    height: 47.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.415,
    y: 676.005,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 0,
    width: 35.6,
    height: 39.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.629999999999995,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.43,
    y: 0,
    width: 36.99,
    height: 39.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.62375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.92500000000001,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.41,
    y: 0,
    width: 38.54,
    height: 39.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.505714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.67999999999999,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.95,
    y: 0,
    width: 38.87,
    height: 39.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.385,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.82,
    y: 0,
    width: 39.25,
    height: 39.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.90625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.445,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.07,
    y: 0,
    width: 39.91,
    height: 39.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.701428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.02499999999998,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.98,
    y: 0,
    width: 40.26,
    height: 39.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.99125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.11,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.24,
    y: 0,
    width: 40.39,
    height: 39.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.435,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.63,
    y: 0,
    width: 40.54,
    height: 39.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.9,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.17,
    y: 0,
    width: 42.57,
    height: 39.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.45500000000004,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.74,
    y: 0,
    width: 43.57,
    height: 39.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.99125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.52500000000003,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.31,
    y: 0,
    width: 44.4,
    height: 39.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.51,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.7,
    y: 0,
    width: 46.54,
    height: 39.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.97,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.24,
    y: 0,
    width: 46.78,
    height: 39.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.63,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.02,
    y: 0,
    width: 47.58,
    height: 39.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.81,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.6,
    y: 0,
    width: 49.4,
    height: 39.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.3000000000001,
    y: 19.965,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 39.93,
    width: 48.49,
    height: 42.38,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 61.120000000000005,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 82.31,
    width: 48.49,
    height: 43.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 103.91,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 125.51,
    width: 48.49,
    height: 43.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 147.34,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 169.17,
    width: 48.49,
    height: 43.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.284285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 191.165,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 213.16,
    width: 48.49,
    height: 44.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.931999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 235.49,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 257.83,
    width: 48.49,
    height: 45.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 280.735,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 303.64,
    width: 48.49,
    height: 45.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 326.62,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 349.6,
    width: 48.49,
    height: 46.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.262
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 372.755,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 395.91,
    width: 48.49,
    height: 46.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.85875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 419.345,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 442.78,
    width: 48.49,
    height: 49.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.081666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 467.55999999999995,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 492.34,
    width: 48.49,
    height: 50.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.081666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 517.4,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 542.46,
    width: 48.49,
    height: 51.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 568.1850000000001,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 593.91,
    width: 48.49,
    height: 52.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 620.2049999999999,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 646.5,
    width: 48.49,
    height: 53.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.849
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.075,
    y: 673.25,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 39.93,
    width: 44.91,
    height: 58.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.77499999999999,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.23,
    y: 39.93,
    width: 46.55,
    height: 58.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.758333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.505,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.78,
    y: 39.93,
    width: 47.18,
    height: 58.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.37,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.96,
    y: 39.93,
    width: 49.4,
    height: 58.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.488888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.66,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.36,
    y: 39.93,
    width: 53.28,
    height: 58.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.611428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.64,
    y: 39.93,
    width: 55.36,
    height: 58.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.151111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.32,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 39.93,
    width: 58.82,
    height: 58.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.41,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.82,
    y: 39.93,
    width: 62.08,
    height: 58.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.886
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.86,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.9,
    y: 39.93,
    width: 64.33,
    height: 58.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.0649999999999,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.23,
    y: 39.93,
    width: 68.79,
    height: 58.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.886
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.625,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.02,
    y: 39.93,
    width: 71.98,
    height: 58.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.01,
    y: 69.36,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 98.78,
    width: 71.29,
    height: 62.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.471666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 130.195,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 161.62,
    width: 71.29,
    height: 62.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 193.07,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 224.52,
    width: 71.29,
    height: 63.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 256.49,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 288.46,
    width: 71.29,
    height: 71.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 323.99,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 359.52,
    width: 71.29,
    height: 78.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 398.895,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 438.27,
    width: 71.29,
    height: 79.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.258000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 477.79499999999996,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 517.32,
    width: 71.29,
    height: 88.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.921111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 561.71,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 606.1,
    width: 71.29,
    height: 93.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.184285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.965,
    y: 653.0500000000001,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.61,
    y: 98.78,
    width: 81.24,
    height: 87.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.605714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.23000000000002,
    y: 142.77,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.85,
    y: 98.78,
    width: 83.31,
    height: 87.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.505,
    y: 142.77,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.16,
    y: 98.78,
    width: 90.59,
    height: 87.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.663333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.45500000000004,
    y: 142.77,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.74,
    y: 98.78,
    width: 96.16,
    height: 87.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.82,
    y: 142.77,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.9,
    y: 98.78,
    width: 98.52,
    height: 87.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.16,
    y: 142.77,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.42,
    y: 98.78,
    width: 101.58,
    height: 87.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.2099999999999,
    y: 142.77,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.61,
    y: 186.76,
    width: 113.6,
    height: 85.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.298333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.41000000000003,
    y: 229.655,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.61,
    y: 272.55,
    width: 113.6,
    height: 91.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.41000000000003,
    y: 318.325,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.61,
    y: 364.1,
    width: 113.6,
    height: 93.8,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.41000000000003,
    y: 411,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.61,
    y: 457.91,
    width: 113.6,
    height: 110.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.419999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.41000000000003,
    y: 513.1700000000001,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.61,
    y: 568.43,
    width: 113.6,
    height: 131.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.41000000000003,
    y: 634.2149999999999,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 186.76,
    width: 120.73,
    height: 131.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.565,
    y: 252.73,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.93,
    y: 186.76,
    width: 139.91,
    height: 131.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.387999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.885,
    y: 252.73,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.84,
    y: 186.76,
    width: 177.16,
    height: 131.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.193999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.4200000000001,
    y: 252.73,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 318.7,
    width: 157.96,
    height: 148.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.814999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.18,
    y: 393.145,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 467.59,
    width: 157.96,
    height: 232.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.18,
    y: 583.795,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.17,
    y: 318.7,
    width: 279.83,
    height: 179.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.40125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.085,
    y: 408.305,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.17,
    y: 497.91,
    width: 279.83,
    height: 202.09,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.26125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.085,
    y: 598.955,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2012);
export default __webpack_public_path__ + "static/media/2012.6e55935bcf2af6424433b2d763458b83.svg";
export { ForwardRef as ReactComponent };